import { render, staticRenderFns } from "./LogoLink.vue?vue&type=template&id=098712b8&"
import script from "./LogoLink.vue?vue&type=script&lang=ts&"
export * from "./LogoLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports